import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import QualifiedPipelineCoverageChart from "../../PipelineReviewPackage/QualifiedPipelineCoverageChart";

const QualifiedPipelineCoveragePaper = ({
  classes,
  paperTitle,
  qualifiedPipelineCoverageData,
  isQualifiedPipelineCoverageLoading,
  handleQualifiedPipelineDrilldown,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.title}>
            {qualifiedPipelineCoverageData?.title ||
              "Qualified Pipeline Coverage"}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        {isQualifiedPipelineCoverageLoading ? (
          <Skeleton variant="rect" animation="wave" height={350} width="100%" />
        ) : qualifiedPipelineCoverageData?.chartData?.length > 0 ? (
          <QualifiedPipelineCoverageChart
            data={qualifiedPipelineCoverageData.chartData}
            title={qualifiedPipelineCoverageData.title}
            onDrill={handleQualifiedPipelineDrilldown}
            currencySymbol={currencySymbol}
          />
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={200}
          >
            <Typography variant="body2" color="textSecondary">
              No data available
            </Typography>
          </Box>
        )}
      </Paper>
    </Grid>
  );
};

export default QualifiedPipelineCoveragePaper;
